import React, { useEffect, useState, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import Modal from '@mui/material/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaChevronDown } from 'react-icons/fa';
import DisplayTemplate from '../../components/Modals/DisplayTemplate';
import RenamePlaybook from '../../components/Modals/RenamePlaybook';
import { Link } from 'react-router-dom';
import { changePlaybookStatus, changePlaybookStepStatus } from '../../common/api';
import { ToastContainer, toast } from 'react-toastify';


const toolbar = ( { selectedRows, handleMassModal, canExport } ) => {
    return(
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col xs='auto'>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'activate' ) }>Activate</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'disable' ) }>Disable</Dropdown.Item>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}


const Playbook = ( { aid, uid, canExport, playbooks, templates, setCurrent } ) => {
    let params = useParams();
    const [ pb, setPlaybook ] = useState( {
        details: {},
        templates: []
    } );
    const [ exp1, setExp1 ] = useState( true );
    const [ exp2, setExp2 ] = useState( true );
    const [ loading, setLoading ] = useState( true );
    const [ lLists, setLists ] = useState( [] );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ showTmpl, setShowTmpl ] = useState( false );
    const [ modal, setModal ] = useState();
    const [ mode, setMode ] = useState( 'Unknown' );
    
    const handleModal = async ( b ) => {
        const [ pri, sub ] = b.modal.split( '.' );
        const template = b.template;

        console.log( 'button: ', b );
        switch ( pri ) {
            case 'rename-pb':
                setModal( <RenamePlaybook close={() => setShowTmpl( false )} pid={pb.details.pid} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + b.modal );
                return;
        }

        setShowTmpl( true );
    };
    
    const handleAction = async ( b ) => {
        const at = b.modal;
        let update = [];

        console.log( 'button: ', b );
        switch ( at ) {
            case 'change-pb-status':
                update = await changePlaybookStatus( uid, [ { aid: pb.details.aid, pid: pb.details.pid } ], !pb.details.active );
                break;

            default:
                console.log( 'Unknown action type: ' + at );
        }

        if ( update && update.length ) {
            toast.success( `Your changes have been saved`, { theme: 'dark' } );
        } else {
            toast.error( 'Sorry, there was an error changing the status', { theme: 'dark' } );
        }
    };
    
    const handleMassModal = async ( t ) => {
        let shouldOpen = true;

        const list = [];
        selectedRows.forEach( sid => {
            const match = sid.match( /\d+/ );
            if ( match ) {
                const idx = parseInt( match[0], 10 );
                list.push( { aid: pb.details.aid, pid: pb.details.pid, sid: idx } );
            }
        } );

        let update = [];
        switch ( t ) {
            case 'activate':
                console.log( 'calling changePlaybookStatus with: ', list );
                update = await changePlaybookStepStatus( uid, list, true );
                console.log( 'update: ', update );
                break;

            case 'disable':
                update = await changePlaybookStepStatus( uid, list, false );
                break;
    
            default:
                console.log( 'Unknown modal type: ' + t );
        }

        if ( update && update.length ) {
            toast.success( `Your changes have been saved`, { theme: 'dark' } );
        }    
    }

    let cols = [
        { 
            field: 'name', 
            headerName: 'Template', 
            // width: 350, 
            flex: 1,
            renderCell: ( { row } ) => ( row.tid ) ? <Button variant='link' onClick={ () => {
                setModal( <DisplayTemplate sid={row.sid} tid={row.tid} close={ () => setShowTmpl( false ) } objType='tmpl' tmplType={row.channel} /> );
                setShowTmpl( true );
            } }>{row.name}</Button> : row.name, 
        },
        { 
            field: 'channel', 
            headerName: 'Action', 
            type: 'string',
            width: 150,
            renderCell: ( { value } ) => {
                switch ( value ) {
                    case 'email':
                        return 'Send Email';
                    case 'sms':
                        return 'Send Txt';
                    case 'call':
                        return 'Create Call Task';
                    case 'text':
                    case 'txt':
                        return 'Create Txt Task';
                    case 'task':
                        return 'Create Task';
                    default:
                        return 'Unknown';
                }
            }
        },
        { 
            field: 'interval', 
            headerName: 'Timing', 
            type: 'string',
            renderCell: ( { row } ) => {
                if ( row.interval === 0 ) {
                    return 'On Event';
                }
                if ( row.interval > 0 ) {
                    return `Day ${row.interval}`;
                }
                if ( row.repeats ) {
                    return row.repeats;
                }
                return 'Unknown';
            }
        },
        { 
            field: 'time', 
            headerName: 'Send At', 
            type: 'string',
            renderCell: ( { row } ) => {
                if ( row.interval === 0 ) {
                    return '-----';
                }
                return row.time;
            }
        },
        { field: 'active', headerName: 'Active', type: 'boolean', width: 100 }
    ];

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );
    
    useEffect( () => {
        setCurrent( { pid: params.pid } );
        const pb = playbooks[params.pid];
        if ( pb ) {
            const list = [];
            Object.keys( templates ).forEach( tid => {
                const t = templates[tid];
                if ( t.pid === pb.pid ) {
                    list.push( t );
                }
            } );
            setPlaybook( { 
                details: pb,
                templates: list
            } );
            console.log( 'pb: ', pb );
            console.log( 'templates: ', list );

            if ( pb.steps && pb.steps.length ) {
                pb.steps.forEach( ( s, idx ) => s.sid = `step_${idx}` );
                console.log( 'steps: ', pb.steps );
                setLists( pb.steps );
            }
            setLoading( false );
        }
    }, [ params.pid, playbooks, templates, setCurrent ] );

    useEffect( () => {
        document.title = `Third Floor - ${pb?.details?.name}`;
    }, [ pb?.details?.name ] );

    useEffect( () => {
        if ( pb?.details?.steps ) {
            const sched = pb.details.steps.some( f => f.interval > 0 || f.repeats );
            const rt = pb.details.steps.some( f => f.interval === 0 );

            if ( sched && rt ) {
                setMode( 'Hybrid' );
            } else if ( sched ) {
                setMode( 'Scheduled' );
            } else if ( rt ) {
                setMode( 'Realtime' );
            }
        }
    }, [ pb ] );

    return (
        <Container fluid className='p-0'>
            {/* <ObjModal.Provider value={ { objType, obj, oid, objPick, setDraftValues, openModal, closeModal, setModal } }> */}
                <Row className='tf-page-container'>
                    <Col className='p-0'>
                        <Fragment>
                            <Container fluid>
                                <Row className='tf-contact-cv-name-container py-2 align-items-center'>
                                    <Col className='fs-4'>
                                        {/* { renderIcon() } */}
                                        <span className='ps-3 fw-bold'>{pb?.details?.name}</span>
                                    </Col>
                                    <Col xs='auto' className='text-end'>
                                        <Dropdown as={ButtonGroup}>
                                            <Button className='tf-obj-button' size='sm' onClick={ () => handleModal( { modal: 'rename-pb' } ) }>Re-Name this Playbook</Button>
                                            <Button className='tf-obj-button' size='sm' onClick={ () => handleAction( { modal: 'change-pb-status' } ) }>{pb?.details?.active === true ? 'Disable' : 'Activate' }</Button>
                                        </Dropdown>
                                    </Col>
                                </Row>
                            </Container>
                        </Fragment>
                    </Col>
                </Row>
                <Row>
                    <Col className='pe-0' md={ 12 }>
                        <Row className='tf-section-container mt-0 me-2 p-0'>
                            <Col className='p-0'>
                                <Container fluid className='p-0'>
                                    <Container fluid className='p-0'>
                                        <Accordion expanded={exp1}>
                                            <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExp1( !exp1 ) } />}>
                                                <Row className='align-items-center w-100'>
                                                    <Col><Typography>Details</Typography></Col>
                                                </Row>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <ListGroup variant='flush'>
                                                    <ListGroup.Item className='border-0 py-0'>
                                                        <Row className='align-items-center'>
                                                            <Col className='tf-obj-data-element align-items-center'>
                                                                <Form.Group as={Row} className='tf-form-group align-items-top' controlId='trigger'>
                                                                    <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>Mode</Form.Label>
                                                                    <Col className='tf-form-text-field me-1'>
                                                                        <Form.Control type='text' value={mode}  />
                                                                    </Col>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row className='align-items-center'>
                                                            <Col className='tf-obj-data-element align-items-center'>
                                                                <Form.Group as={Row} className='tf-form-group align-items-top' controlId='trigger'>
                                                                    <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>Audience Description</Form.Label>
                                                                    <Col className='tf-form-text-field me-1'>
                                                                        <Form.Control type='text' value={pb?.details?.rule?.description}  />
                                                                    </Col>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row className='align-items-center'>
                                                            <Col className='tf-obj-data-element align-items-center'>
                                                                <Form.Group as={Row} className='tf-form-group align-items-top' controlId='steps'>
                                                                    <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>Actions</Form.Label>
                                                                    <Col className='tf-form-text-field me-1'>
                                                                        <Form.Control type='text' value={pb?.details?.steps?.length}  />
                                                                    </Col>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion expanded={exp2}>
                                            <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExp2( !exp2 ) } />}>
                                                <Row className='align-items-center w-100'>
                                                    <Col><Typography>Templates</Typography></Col>
                                                </Row>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Row>
                                                    <Col style={ { display: 'flex', height: `400px`, width: '100%' } }>
                                                            <DataGridPro
                                                                // apiRef={gridRef}
                                                                loading={ loading }
                                                                rows={lLists}
                                                                columns={cols}
                                                                density='compact'
                                                                checkboxSelection
                                                                disableSelectionOnClick
                                                                slots={ { toolbar: toolbar } }
                                                                slotProps={ { toolbar: {
                                                                    selectedRows: selectedRows, 
                                                                    handleMassModal: handleMassModal,
                                                                    canExport: canExport,
                                                                } } }
                                                                onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                                getRowId={ ( row ) => row.sid }
                                                            />
                                                        
                                                    </Col>
                                                </Row>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Container>
                                </Container>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            {/* </ObjModal.Provider> */}
            <ToastContainer autoClose={3000} />
            <Modal open={showTmpl} onClose={ () => setShowTmpl( false ) }>
                <Fragment>
                    {modal}
                </Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    canExport: state.user.canExport,
    playbooks: state.playbooks.byId,
    templates: state.templates.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    setCurrent: dispatch.playbooks.setCurrent
} );
  
export default connect( mapProps, mapDispatch )( Playbook );